import { api } from "./NetworkBase";

export async function GetOrCreateReceiptInformation(identifier) {
	if (!identifier) {
		return;
	}

	let response = await api.get("scannerapp/info/" + identifier).json();
	return response;
}

export async function UpdateReceiptInformation(receiptInfo) {
	let response = await api.post(
		"scannerapp/info/" + encodeURIComponent(receiptInfo.identifier.trim()),
		{
			json: receiptInfo,
		}
	);

	return response.status;
}

export async function UpdateEtkReceiptInformation(receiptInfo) {
	let response = await api.post(
		"scannerapp/info/etk/" + encodeURIComponent(receiptInfo.identifier.trim()),
		{
			json: receiptInfo,
		}
	);

	return response.status;
}

// Loads one already-submitted check-in sheet so the user can correct it. The
// response carries the sheet's own samples for read-only display.
export async function GetCheckInSheet(identifier, recordId) {
	if (!identifier || !recordId) {
		return;
	}

	let response = await api
		.get(
			"scannerapp/info/" +
				encodeURIComponent(identifier.toString().trim()) +
				"/sheet/" +
				recordId
		)
		.json();

	return response;
}

// Saves edits to an existing check-in sheet. Which samples the sheet covers is
// fixed server-side, so nothing about the selection is sent.
export async function UpdateExistingCheckInSheet(identifier, recordId, receiptInfo) {
	let response = await api.put(
		"scannerapp/info/" +
			encodeURIComponent(identifier.toString().trim()) +
			"/sheet/" +
			recordId,
		{
			json: receiptInfo,
		}
	);

	return response.status;
}
